import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { api } from '@src/app/app.const';
import { AppApiService } from '@src/app/core/services/app-api.service';

@Component({
  selector: 'app-reset-temp-password-dialog',
  templateUrl: './reset-temp-password-dialog.component.html',
  styleUrls: ['./reset-temp-password-dialog.component.css'],
  standalone: false,
})
export class ResetTempPasswordDialogComponent {
  private userName: string;

  constructor(
    private _appApiService: AppApiService,
    private dialogRef: MatDialogRef<ResetTempPasswordDialogComponent>,
    @Inject(MAT_DIALOG_DATA) private _data: any
  ) {
    this.userName = _data.userName;
  }

  async onResetTempPassword(): Promise<void> {
    this._appApiService
      .postWithoutToken(api.webview.name, `user/resetTempPassword`, {
        body: {
          userName: this.userName,
        },
      })
      .then(() => {
        this.dialogRef.close(true);
      });
  }
}
